export const TOP_UP_PACKAGE_KEYS = {
  NORMAL: "normal",
  GOLD: "gold",
  PLATINUM: "platinum",
  MEMBERSHIP: "membership",
  FIRST_5KG_SPECIAL: "first_5_kg_special",
  FO0KAI_6_50: "fookai_6_50",
  FO0KAI_SPECIAL: "fookai_special",
  SUPER_MEMBERSHIP: "super_membership",
  DHL_RM_5_MEMBERSHIP: "dhl_rm_5_membership",
  NEW_YEAR_300: "new_year_300",
  PARTNERS: "partners",
  REAL_WEIGHT: "real_weight",
  NINJA_SPECIAL: "ninja_special",
  DHL_RM_4_90: "dhl_rm_4_90",
  SPX: "spx",
  DAILY_SPECIAL: "daily_special",
  BEDDING: "bedding",
  SUPER_VIP: "super_vip",
  VVIP: "vvip",
  DIAMOND: "diamond",
  SALES_1: "sales_1",
  SALES_2: "sales_2",
  SALES_3: "sales_3",
  PD_NORMAL: "pd_normal",
  PD_GOLD: "pd_gold",
  PD_PLATINUM: "pd_platinum",
  WELCOME_DEAL: "welcome_deal",
  WELCOME_ELITE: "welcome_elite",
  JST_1: "jst_1",
  JST_2: "jst_2",
  JST_3: "jst_3",
  SPECIAL_2026_1: "2026_special_1",
  SPECIAL_2026_2: "2026_special_2",
  SPECIAL_2026_3: "2026_special_3",
  SPECIAL_2026_4: "2026_special_4",
  SPECIAL_2026_5: "2026_special_5",
  SPECIAL_2026_6: "2026_special_6",
  SPECIAL_2026_7: "2026_special_7",
  SPECIAL_2026_8: "2026_special_8"
};

export const TOP_UP_PACKAGES = {
  [TOP_UP_PACKAGE_KEYS.NORMAL]: { name: "Normal", color: "grey" },
  [TOP_UP_PACKAGE_KEYS.GOLD]: { name: "Gold", color: "gold" },
  [TOP_UP_PACKAGE_KEYS.PLATINUM]: { name: "Platinum", color: "#E5E4E2" },
  [TOP_UP_PACKAGE_KEYS.MEMBERSHIP]: { name: "Membership" },
  [TOP_UP_PACKAGE_KEYS.FIRST_5KG_SPECIAL]: { name: "First 5kg Special" },
  [TOP_UP_PACKAGE_KEYS.FO0KAI_6_50]: { name: "Fookai 6.50" },
  [TOP_UP_PACKAGE_KEYS.FO0KAI_SPECIAL]: { name: "Fookai Special" },
  [TOP_UP_PACKAGE_KEYS.SUPER_MEMBERSHIP]: { name: "Super Membership" },
  [TOP_UP_PACKAGE_KEYS.DHL_RM_5_MEMBERSHIP]: { name: "DHL RM5 Membership" },
  [TOP_UP_PACKAGE_KEYS.NEW_YEAR_300]: { name: "New Year Promo" },
  [TOP_UP_PACKAGE_KEYS.PARTNERS]: { name: "Partners" },
  [TOP_UP_PACKAGE_KEYS.REAL_WEIGHT]: { name: "Real Weight" },
  [TOP_UP_PACKAGE_KEYS.NINJA_SPECIAL]: { name: "Ninja Special" },
  [TOP_UP_PACKAGE_KEYS.DHL_RM_4_90]: { name: "DHL RM 4.90" },
  [TOP_UP_PACKAGE_KEYS.SPX]: { name: "SPX" },
  [TOP_UP_PACKAGE_KEYS.DAILY_SPECIAL]: { name: "Daily Special" },
  [TOP_UP_PACKAGE_KEYS.BEDDING]: { name: "Bedding" },
  [TOP_UP_PACKAGE_KEYS.SUPER_VIP]: { name: "Super VIP" },
  [TOP_UP_PACKAGE_KEYS.VVIP]: { name: "VVIP" },
  [TOP_UP_PACKAGE_KEYS.DIAMOND]: { name: "Diamond" },
  [TOP_UP_PACKAGE_KEYS.SALES_1]: { name: "Sales 1" },
  [TOP_UP_PACKAGE_KEYS.SALES_2]: { name: "Sales 2" },
  [TOP_UP_PACKAGE_KEYS.SALES_3]: { name: "Sales 3" },
  [TOP_UP_PACKAGE_KEYS.PD_NORMAL]: { name: "PD Normal" },
  [TOP_UP_PACKAGE_KEYS.PD_GOLD]: { name: "PD Gold" },
  [TOP_UP_PACKAGE_KEYS.PD_PLATINUM]: { name: "PD Platinum" },
  [TOP_UP_PACKAGE_KEYS.WELCOME_DEAL]: { name: "Welcome Deal" },
  [TOP_UP_PACKAGE_KEYS.WELCOME_ELITE]: { name: "Welcome Elite" },
  [TOP_UP_PACKAGE_KEYS.JST_1]: { name: "JST 1" },
  [TOP_UP_PACKAGE_KEYS.JST_2]: { name: "JST 2" },
  [TOP_UP_PACKAGE_KEYS.JST_3]: { name: "JST 3" },
  [TOP_UP_PACKAGE_KEYS.SPECIAL_2026_1]: { name: "2026 Special 1" },
  [TOP_UP_PACKAGE_KEYS.SPECIAL_2026_2]: { name: "2026 Special 2" },
  [TOP_UP_PACKAGE_KEYS.SPECIAL_2026_3]: { name: "2026 Special 3" },
  [TOP_UP_PACKAGE_KEYS.SPECIAL_2026_4]: { name: "2026 Special 4" },
  [TOP_UP_PACKAGE_KEYS.SPECIAL_2026_5]: { name: "2026 Special 5" },
  [TOP_UP_PACKAGE_KEYS.SPECIAL_2026_6]: { name: "2026 Special 6" },
  [TOP_UP_PACKAGE_KEYS.SPECIAL_2026_7]: { name: "2026 Special 7" },
  [TOP_UP_PACKAGE_KEYS.SPECIAL_2026_8]: { name: "2026 Special 8" },
};
